"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
  position: absolute;
  left: 10vh;
  bottom: 10vh;
  padding: 16px;
  background-color: white;
  border: 1px black solid;
  width: 80vh;
`;
const Title = styled_components_1.default.h1 `
  font-family: CatV, monospace;
`;
const Text = styled_components_1.default.p `
  font-family: CatV, monospace;
`;
const Form = styled_components_1.default.form `
  display: flex;
`;
const ActionButton = styled_components_1.default.button `
  outline: none;
  border: 1px solid black;
  margin: 16px;
  padding: 8px;
  font-family: CatV, monospace;
  color: black;
  cursor: pointer;

  &:hover {
    color: #fa00dd;
  }
`;
const Input = styled_components_1.default.input `
  font-family: CatV, sans-serif;
  border: 1px solid black;
  margin: 16px;
  padding: 8px;
  display: block;
  flex-grow: 10;
`;
const RiddleUI = ({ state, guess, status, loading }) => {
    const [inputText, setInputText] = react_1.useState("");
    const onSubmit = (e) => {
        e.preventDefault();
        guess(inputText);
    };
    if (!state || loading) {
        return (react_1.default.createElement(Container, null,
            react_1.default.createElement(Title, null, "Loading...")));
    }
    else if ((state === null || state === void 0 ? void 0 : state.state) === "DONE") {
        return (react_1.default.createElement(Container, null,
            react_1.default.createElement(Title, null, "Congratulations!! Riddle Complete :o")));
    }
    else {
        return (react_1.default.createElement(Container, null,
            status && react_1.default.createElement(Text, null, status),
            react_1.default.createElement(Title, null,
                "Clue: ",
                state.clue),
            state.state === "SOLVING_HINT" && react_1.default.createElement(Text, null,
                "Hint: ",
                state.hint),
            react_1.default.createElement(Form, { onSubmit: onSubmit },
                react_1.default.createElement(Input, { type: "text", placeholder: "Enter a guess, or don't..w/e", value: inputText, onChange: (e) => setInputText(e.target.value) }),
                react_1.default.createElement(ActionButton, null, "Guess"))));
    }
    console.warn("RiddleUI in invald state");
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = RiddleUI;
//# sourceMappingURL=data:application/json;base64,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